const statuses = {
  10: ['waiting', 'blue'], 11: ['processing', 'blue'], 12: ['partial', 'yellow'],
  20: ['succeeded', 'green'], 21: ['failed', 'red'], 30: ['manual', 'yellow'],
  0: ['legacy', 'gray'], 1: ['legacy', 'gray'], 2: ['legacy', 'gray']
};

export function withdrawalStatus(status) {
  const [key, tone] = statuses[status] || ['unknown', 'gray'];
  return { key: `withdraw.${key}`, tone };
}

function feeAmount(withdrawFee = 10) {
  const fee = Number(withdrawFee);
  return Number.isFinite(fee) && fee >= 0 ? fee : 10;
}

export function minimumWithdrawalAmount(withdrawFee = 10) {
  return Math.round((100 + feeAmount(withdrawFee)) * 100) / 100;
}

export function receiveAmount(value, withdrawFee = 10) {
  const amount = Number(value);
  if (!Number.isFinite(amount)) return 0;
  return Math.max(0, Math.round((amount - feeAmount(withdrawFee)) * 100) / 100);
}

export function withdrawalError(wallet, value, withdrawFee = 10) {
  if (!wallet) return 'errors.walletChanged';
  if (Number(wallet.lifecycle) === 6) return 'status.withdrawSettling';
  if (Number(wallet.lifecycle) !== 2) return 'errors.walletChanged';
  const available = wallet.withdrawable;
  if (!(typeof available === 'number' || (typeof available === 'string' && available.trim() !== '')) || !Number.isFinite(Number(available))) return 'withdraw.balanceUnknown';
  const amount = Number(value);
  if (!Number.isFinite(amount) || !/^\d+(\.\d{1,2})?$/.test(String(value))) return 'withdraw.invalidAmount';
  if (amount > 50000) return 'withdraw.maximum';
  if (amount < minimumWithdrawalAmount(withdrawFee)) return 'withdraw.minimum';
  if (wallet.walletType === 'Nagad' && !Number.isInteger(receiveAmount(value, withdrawFee))) return 'withdraw.nagadWholeAmount';
  if (!Number.isFinite(Number(wallet.withdrawable)) || amount > Number(wallet.withdrawable)) return 'withdraw.exceedsBalance';
  return '';
}

export function requestKey() {
  // Web Crypto also works on localhost; never use weak randomness for idempotency.
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 15) | 64;
  bytes[8] = (bytes[8] & 63) | 128;
  const hex = Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

export function withdrawalDate(value, locale = 'en') {
  if (value === null || value === undefined || value === '') return '--';
  // Backend wall-clock timestamps are interpreted as Bangladesh time, not device time.
  let input = value;
  if (Array.isArray(input)) {
    if (input.length < 3 || input.length > 7 || !input.every(Number.isInteger)) return '--';
    const [year, month, day, hour = 0, minute = 0, second = 0, nano = 0] = input;
    if (year < 1000 || year > 9999 || month < 1 || month > 12 || day < 1
        || day > new Date(Date.UTC(year, month, 0)).getUTCDate()
        || hour < 0 || hour > 23 || minute < 0 || minute > 59 || second < 0 || second > 59
        || nano < 0 || nano > 999999999) return '--';
    const pad = number => String(number).padStart(2, '0');
    input = `${year}-${pad(month)}-${pad(day)}T${pad(hour)}:${pad(minute)}:${pad(second)}+06:00`;
  }
  if (typeof input === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(input)) input += 'T00:00:00+06:00';
  if (typeof input === 'string' && /^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}:\d{2}(\.\d+)?$/.test(input)) {
    input = input.replace(' ', 'T') + '+06:00';
  }
  const date = new Date(input);
  return Number.isFinite(date.getTime()) ? date.toLocaleString(locale === 'bn' ? 'bn-BD' : 'en-GB', {
    timeZone: 'Asia/Dhaka', year: 'numeric', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: true
  }) : '--';
}
